import { useEffect, useRef } from 'react';
import useInterval from './useInterval';

const useOnIdle = (callback: () => void, idleTime?: number) => {
    const ref = useRef<number>(0);

    useInterval(() => {
        ref.current = ref.current + 1;
        if (idleTime && ref.current > idleTime) {
            callback();
            ref.current = 0;
        }
    }, 1000);

    useEffect(() => {
        document.addEventListener('mousemove', () => (ref.current = 0));
        document.addEventListener('keydown', () => (ref.current = 0));
        document.addEventListener('click', () => (ref.current = 0));

        return () => {
            document.removeEventListener('mousemove', () => (ref.current = 0));
            document.removeEventListener('keydown', () => (ref.current = 0));
            document.removeEventListener('click', () => (ref.current = 0));
        };
    }, [ref.current]);
};

export default useOnIdle;
